export const SPINNER_CHANGED = "SPINNER_CHANGED";

export const spinnerChangedAction = isLoading => ({
    type: SPINNER_CHANGED,
    isLoading
})